import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'

const styles = theme => ({

  contents: {
    ...Contents(theme)
  },
  section: {
    background: 'rgba(255,255,255,1)',
    padding: '3rem 7rem',
    maxWidth: 1024,
    [theme.breakpoints.down('sm')]: {
      padding: '2rem 2rem',
    },
  },
  sectionImage: {
    width: '100%',
    maxWidth: 1024,
    marginBottom: theme.spacing.unit * 4
  },
  text: {
    ...RichText(theme),
  },

})

export default styles



// WEBPACK FOOTER //
// ./src/components/section/styles.js